export const assetUrl = '/services/plugin-aeapps-resources-manager/'

export const api = {
    generalAssets: {
        generalAssets: 'generalassets' // TODO: CHANGE BACKEND API ENDPOINT LATER SINCE ITS NOT ASSET ANYMORE
    },
    assetType: {
        assetTypes: 'assettypes' // TODO: CHANGE BACKEND API ENDPOINT LATER SINCE ITS NOT ASSET ANYMORE
    },
    assetExtensions: {
        assetExtensions: 'assetextensions' // TODO: CHANGE BACKEND API ENDPOINT LATER SINCE ITS NOT ASSET ANYMORE
    },
    basicInfo: {
        basicInfo: 'assetinfos/basicinfo/asset' // TODO: CHANGE BACKEND API ENDPOINT LATER SINCE ITS NOT ASSET ANYMORE
    },
    assetInfo: {
        assetInfo: 'assetinfos' // TODO: CHANGE BACKEND API ENDPOINT LATER SINCE ITS NOT ASSET ANYMORE
    },
    resourceGroup: {
        resourceGroup: 'resourcegroup'
    }
}
